<!--
 * @Author: guoyu
 * @Date: 2020-11-27 10:04:19
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-04 14:58:56
 * @Description: file content
-->
<template>
  <div class="detail-page">
    <div class="user-info-header">
      <fps-avatar
        class="player-avatar"
        :src="masterInfo.avatarUrl"
      ></fps-avatar>
      <span class="header-nickname">{{ masterInfo.nickname }}</span>
      <span
        class="userlevel-tag level-mg big-level-tag"
        v-if="isSelf"
        :class="`level-${masterInfo.userLevel}`"
      ></span>
      <div class="line-status">
        <i
          v-if="isOnline"
          class="online-circle-wrap"
          :class="{ 'is-online-wrap': isOnline }"
        ></i>
        <span class="online-text">{{
          isOnline ? $t('upgrade_page_views_master_index_206') : $util.onlineTime(masterInfo)
        }}</span>
      </div>
      <coupon-banner
        class="coupon-banner"
        :title="$t('upgrade_page_views_master_index_207')"
        v-if="!(this.userInfo && this.userInfo.uuid) && isRedBagWhiteList"
        @click.native="showPlayerRedbag()"
      ></coupon-banner>
    </div>
    <div class="play-detail">
      <div class="page-left">
        <div class="left-top">
          <img v-if="tagsAdmin" class="tags-admin" :src="tagsAdmin" />
          <UserImage
            class="photo-list"
            :imageList="masterInfo.photoAlbumVoList"
          ></UserImage>
          <div class="score-info">
            <div class="validate-tag">
              <FaceValidate
                v-if="masterInfo.faceSuccess"
                class="self-photo"
                :nickname="masterInfo.nickname"
                :userUuid="masterInfo.uuid"
                :showText="true"
              />
              <div class="nicee-account" v-if="isAdmin">
                <fps-icon
                  class="admin-icon"
                  type="v-mark"
                  size="15"
                  color="#FFA24E"
                />{{$t('upgrade_page_views_master_index_208')}}</div>
            </div>

            <div v-if="masterInfo.follower" class="follow-num">
              <span class="score-type">{{$t('upgrade_page_views_master_index_209')}}</span>
              <span class="score-value">
                {{ masterInfo.follower }}
              </span>
            </div>
            <div
              v-if="masterInfo.playerScore"
              class="score-num"
              @click="openScorePopup"
            >
              <span>{{$t('upgrade_page_views_master_index_210')}}</span>
              <span>{{ masterInfo.playerScore.toFixed(0) }}</span>
              <fps-icon type="question" size="15" />
            </div>
            <!-- <template v-else></template> -->
            <div class="score-num">
              <img
                v-if="isFindBoss"
                style="width:20px;height:20px"
                src="~@/assets/image/icons/find-boss.png"
              />
            </div>
            <ShouhuIcon
              class="strongest"
              :masterInfo="masterInfo"
              v-if="masterInfo.strongest"
            ></ShouhuIcon>
          </div>
          <div class="user-info">
            <div class="row-info nickname-row">
              <span class="row-name">{{$t('upgrade_page_views_master_index_211')}}</span>
              <span>{{ masterInfo.nickname }}</span>
              <span
                class="sex"
                v-if="masterInfo.age || sex"
                :class="'sex-' + sex"
                ><i class="sex-icon" :class="'el-icon-' + sex"></i
                >{{ masterInfo.age || '' }}</span
              >
            </div>
            <div class="row-info uuid-row" @click="copyUuid()">
              <span class="row-name">ID</span>
              <uuid-vue ref="uuidVue" :userUuid="masterInfo.uuid"></uuid-vue>
              <i class="copy-uuid-icon el-icon-copy-document"></i>
            </div>
            <div class="row-info link-box" v-if="masterInfo.fbUrl">
              <span class="row-name">Facebook</span>
              <a class="link-url" :href="masterInfo.fbUrl" target="_blank">{{
                masterInfo.fbUrl
              }}</a>
            </div>
            <div class="row-info link-box" v-if="masterInfo.igUrl">
              <span class="row-name">Instagram</span>
              <a class="link-url" :href="masterInfo.fbUrl" target="_blank">{{
                masterInfo.igUrl
              }}</a>
            </div>
            <LineControl
              class="player-desc"
              v-if="masterInfo.description"
              :rows="2"
            >
              <el-input
                v-model="masterInfo.description"
                type="textarea"
                class="wrap-text"
                autosize
                resize="none"
                disabled
              />
            </LineControl>
          </div>
          <FPSButton class="edit-info" v-if="isSelf" @click="editInfo"
            ><fps-icon type="edit" size="24" color="#222C43" />{{$t('upgrade_page_views_master_index_212')}}</FPSButton
          >
          <SomeHandle
            class="some-handle"
            v-if="isPC"
            :isSelf="isSelf"
            :playerInfo="masterInfo"
            :userInfo="userInfo"
          ></SomeHandle>
        </div>
        <RankList
          class="order-rank"
          v-if="isPC && isPlayer"
          :masterUuid="masterInfo.uuid"
        ></RankList>
        <MyGift
          v-if="masterInfo.uuid && isPC"
          :masterUuid="masterInfo.uuid"
          :playerInfo="masterInfo"
          :isSelf="isSelf"
        ></MyGift>
      </div>
      <div class="page-right">
        <div class="right-tab">
          <!-- <div
            class="tab-item"
            :class="{ 'tab-active': currenteSkillTab === -1 }"
            @click="currenteSkillTab = -1"
          >
            <span>動態</span>
          </div> -->
          <SwiperCollapse
            class="skill-tab"
            :options="swiperList"
            :sNum="3"
            :val="slideTab"
          >
            <template v-slot="{ item, index }">
              <div
                class="tab-item"
                :class="{ 'tab-active': currenteSkillTab === index }"
                @click="getCurrent(index)"
              >
                <span>{{ item.gameName }}</span>
              </div>
            </template>
          </SwiperCollapse>
        </div>
        <template v-if="isPlayer">
          <SkillInfo
            v-for="(item, index) in masterInfo.playerSkillVoList"
            v-show="item.id === currentSkillInfo.id && currenteSkillTab > 0"
            :isShow="item.id === currentSkillInfo.id && currenteSkillTab > 0"
            :key="'s' + index"
            :skillInfo="item"
            :playerInfo="masterInfo"
            :userInfo="userInfo"
            :isSelf="isSelf"
            :min7Mode="min7Mode"
            :ref="'SkillInfo' + index"
            @switchToVoice="switchToVoice"
          ></SkillInfo>
        </template>
        <FeedList
          v-show="currenteSkillTab === 0"
          class="list-wrap"
          :playerUuid="masterInfo.uuid"
          @getFeed="askFeed"
        ></FeedList>
      </div>
    </div>
    <ScoreExplain
      v-model="scorePopupStatus"
      :popupType="scorePopupType"
      :score="masterInfo.playerScore || 0"
      :isGood="masterInfo && masterInfo.alertScore"
    />
  </div>
</template>

<script>
import i18n from '@/locales'
import { getMasterInfo, getFollowInfo } from '@/api/app';
import { mapGetters } from 'vuex';
import UserImage from './components/user-imags';
import SkillInfo from './components/skill-info/index';
import ScoreExplain from '@/components/ScoreExplain';
import ShouhuIcon from './components/shouhu-dialog';
import SomeHandle from './components/some-handle';
import RankList from './components/rank-list';
import MyGift from './components/my-gift';
import FeedList from '@/upgrade-page/views/user-feed/feed-list';
import SwiperCollapse from '@/components/common/swiper/swiper-collapse';
import FaceValidate from '@/components/FaceValidate';
import LineControl from '@/components/common/text/line-control';
import FPSButton from '@/components/common/button/normal';
import PlayerRedbag from '@/components/Login/components/player-redbag';
import AmountCoponent from '@/components/common/amount/global-amount.jsx';
import CouponBanner from '@/components/common/coupon-banner';
import UuidVue from '@/components/UserInfo/uuid.vue';

export default {
  components: {
    UserImage,
    ScoreExplain,
    SkillInfo,
    ShouhuIcon,
    SomeHandle,
    RankList,
    FeedList,
    SwiperCollapse,
    MyGift,
    FaceValidate,
    LineControl,
    FPSButton,
    CouponBanner,
    'uuid-vue': UuidVue
  },
  data() {
    return {
      masterInfo: {
        photoAlbumVoList: []
      },
      currentMasterId: '',
      isSelf: false,
      scorePopupStatus: false,
      scorePopupType: '',
      currenteSkillTab: 0,
      slideTab: 0 // 控制左滑数
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'adminUuid', 'systemUuid', 'aliasList']),
    // 是否发现老板
    isFindBoss() {
      if (!this.masterInfo || !this.masterInfo.labelList) return false;
      return this.masterInfo.labelList.find(item => item.labelId == '17');
    },
    isAdmin() {
      return (
        this.masterInfo.uuid == this.adminUuid ||
        this.systemUuid.find(id => {
          return id == this.masterInfo.uuid;
        })
      );
    },
    currentSkillInfo() {
      if (!this.masterInfo.playerSkillVoList) return {};
      if (this.currenteSkillTab < 0) {
        return this.masterInfo.playerSkillVoList[0];
      }
      const skillIndex =
        this.currenteSkillTab - 1 < 0 ? 0 : this.currenteSkillTab - 1;
      return this.masterInfo.playerSkillVoList[skillIndex];
    },
    isOnline() {
      return this.$util.isOnline(this.masterInfo);
    },
    tagsAdmin() {
      const labels = this.masterInfo.labelList;
      if (!labels || !labels.length) return '';
      const admin = labels.filter(item => item.showType === 'AvatarFrame')[0];
      if (!admin) return '';
      return admin.webUrl;
    },
    sex() {
      let s = this.masterInfo.sex || '';
      return s.toLocaleLowerCase();
    },
    sexText() {
      const sexList = {
        female: i18n.t('upgrade_page_views_master_index_213'),
        male: i18n.t('upgrade_page_views_master_index_214')
      };
      return sexList[this.sex];
    },
    isPlayer() {
      return this.masterInfo.userKind === 'Player';
    },
    swiperList() {
      if (!this.masterInfo.playerSkillVoList) return [{ gameName: i18n.t('upgrade_page_layout_header_8') }];
      return [{ gameName: i18n.t('upgrade_page_layout_header_8') }].concat(this.masterInfo.playerSkillVoList);
    },
    min7Mode() {
      let voiceSkill = this.masterInfo.playerSkillVoList.find(
        v => v.gameId == 36
      );
      return (
        voiceSkill &&
        voiceSkill.skillPriceList.find(v => v.salesUnit == 'Minutes7')
      );
    },
    isRedBagWhiteList() {
      const whiteList = this.aliasList.map(item => {
        return item.userUuid;
      });
      // process.env.VUE_APP_ENV === 'production'
      //   ? ['10001', '1054918']
      //   : ['1000811'];
      return (
        this.masterInfo &&
        whiteList.includes(this.masterInfo.uuid) &&
        this.isPlayer
      );
    }
  },
  watch: {
    userInfo(curVal) {
      if (curVal) this.getMasterDetail();
      this.isSelf = curVal && curVal.uuid === this.masterInfo.uuid;
    }
  },
  methods: {
    editInfo() {
      this.$router.push({
        path: '/user-info'
      });
    },
    /**
     * @description: 选择当前展示块
     * @param {*} index
     * @return {*}
     */
    getCurrent(index) {
      this.currenteSkillTab = index;
      this.slideTab = index;
    },
    /**
     * @description: 是否有動態信息，有動態則動態展示默認優先
     * @param {*}
     * @return {*}
     */
    askFeed(feedList) {
      if (!feedList.length && this.currenteSkillTab === 0 && this.isPlayer) {
        this.currenteSkillTab = 1;
      }
    },
    showStrongest() {
      if (this.$util.nativeType) {
        window.loadApp({
          title: i18n.t('upgrade_page_views_master_index_215', [this.masterInfo.nickname]),
          content: `${this.masterInfo.nickname}現在在線，使用app可以與${
            this.masterInfo.sex === 'Male' ? '他' : i18n.t('upgrade_page_views_master_index_216')
          }有更多互動喔！`,
          showCancelButton: false,
          showClose: true
        });
      } else {
        this.showStrongestDialog = true;
      }
    },
    openScorePopup() {
      // 如果是自己并且查看的是b端用户
      if (this.isSelf && this.isPlayer) {
        this.scorePopupType = 'ScoreBExplain';
      } else {
        this.scorePopupType = 'ScoreCExplain';
      }
      this.scorePopupStatus = true;
    },
    getMasterDetail() {
      getMasterInfo({
        uuid: this.currentMasterId
      }).then(({ data }) => {
        this.masterInfo = data;
        this.showPlayerRedbag();

        // 确保初始选中技能是第二位，動態第一位
        let selectSkill;
        if (this.$route.query.skillId && this.masterInfo.playerSkillVoList) {
          let skillList = this.masterInfo.playerSkillVoList.reduce(
            (pre, item) => {
              if (item.id != this.$route.query.skillId) {
                pre.push(item);
              } else {
                selectSkill = item;
              }
              return pre;
            },
            []
          );
          this.masterInfo.playerSkillVoList = skillList;
        }
        if (selectSkill) {
          this.masterInfo.playerSkillVoList.unshift(selectSkill);
          this.currenteSkillTab = 1;
        } else {
          this.currenteSkillTab = 0;
        }
        getFollowInfo({ uuid: this.currentMasterId }).then(({ data }) => {
          let { followStatus, follower } = data;
          this.masterInfo = { ...this.masterInfo, followStatus, follower };
        });
        const titleTag = document.getElementsByTagName('title');
        titleTag[0].text = i18n.t('upgrade_page_views_master_index_217', [this.masterInfo.nickname]);
      });
    },
    showPlayerRedbag() {
      console.log('showPlayerRedbag');
      if (!(this.userInfo && this.userInfo.uuid) && this.isRedBagWhiteList) {
        const DisplayPlayerRedbag = AmountCoponent(PlayerRedbag, {
          props: {
            nickName: this.masterInfo.nickname,
            uuid: this.masterInfo.uuid
          }
        });
        DisplayPlayerRedbag();
      }
    },
    switchToVoice() {
      let idx =
        this.masterInfo.playerSkillVoList.findIndex(v => v.gameId == 36) + 1;
      if (idx > 0) {
        this.getCurrent(idx);
        let ref = this.$refs['SkillInfo' + (idx - 1)];
        let component = ref && ref[0];
        let baseInfo = component.$children.find(
          v => v.$options.name == 'BaseInfo'
        );
        baseInfo && baseInfo.selectPrice(this.min7Mode);
      }
    },
    copyUuid() {
      console.log(this.$refs['uuidVue']);
      this.$refs['uuidVue'].copyUuid();
    }
  },
  async created() {
    let uuid = this.$route.params.uuid;
    let aliasName = '';
    //链接为https://nicee.tw/player-detail/4405123&skillId=-1时，4405123&skillId=-1会被当作别名处理，所以要特殊处理
    if (this.$route.params.aliasName) {
      const index = this.$route.params.aliasName.indexOf('&');
      if (index != -1) {
        uuid = this.$route.params.aliasName.slice(0, index);
      } else {
        aliasName = this.$route.params.aliasName;
      }
    }

    if (window.innerWidth < 600) {
      const url = aliasName
        ? `h5invokeapp:///player-detail/${aliasName}`
        : `h5invokeapp:///player-detail?uuid=${uuid}`;
      window.location.href = url;
    }
    if (!this.aliasList) {
      this.$store.dispatch('app/setAliasList');
    }
    try {
      if (aliasName) {
        const { data } = await this.$http.get('/user/getUuidByAlias', {
          alias: aliasName
        });
        if (data) {
          this.currentMasterId = data;
        } else {
          this.$router.push({ path: '/' });
          return;
        }
      } else {
        this.currentMasterId = uuid;
      }
      this.isSelf =
        this.userInfo && this.userInfo.uuid === this.currentMasterId;
      this.getMasterDetail();
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    setTimeout(() => {
      this.$adjust('web_skill_page_view', {
        user_id: this.$route.params.uuid
      });
    }, 1000);
  }
};
</script>
<style lang="scss" scoped>
.detail-page {
  padding: 16px 0 110px;
  color: #222c43;
}
.play-detail {
  display: flex;
  width: 1100px;
  justify-content: space-between;
}
.user-info-header {
  display: flex;
  align-items: center;
  height: 33px;
  margin: 0 0 12px;
}
.player-avatar {
  height: 33px;
  width: 33px;
  border: 2px solid #ffffff;
  margin-right: 16px;
  border-radius: 50%;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
}
.header-nickname {
  margin-right: 2px;
  font-size: 20px;
  font-weight: 600;
}
.line-status {
  margin-left: 24px;
}
.online-text {
  font-size: 15px;
  color: #636d86;
}
.page-left {
  position: relative;
  width: 365px;
}
.page-right {
  width: 720px;
  border: 1px solid #efefef;
  margin-left: 16px;
  flex-grow: 1;
  flex-shrink: 0;
  background: #ffffff;
  border-radius: 4px;
}
.left-top {
  padding-bottom: 4px;
  background: #ffffff;
}
.sex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 18px;
  padding: 0 6.25px;
  margin: 2px 0 0 8px;
  font-size: 12px;
  background: #ff81b6;
  border-radius: 20px;
  color: #ffffff;
}
.sex-male {
  background: #5362ec;
}
.sex-icon {
  margin-right: 4px;
  font-weight: 700;
}
.tags-admin {
  position: absolute;
  z-index: 10;
  left: 8px;
  top: 8px;
  width: auto;
  height: 30px;
}
.photo-list {
  margin-bottom: 24px;
}
.score-info {
  position: absolute;
  top: 307px;
  width: 100%;
  height: 138px;
  padding: 76px 16px 0;
  font-size: 15px;
  background: linear-gradient(
    360deg,
    rgba(0, 0, 0, 0.67) 16.77%,
    rgba(0, 0, 0, 0.2) 68.24%,
    rgba(0, 0, 0, 0) 95.21%
  );
  color: #ffffff;
}
.follow-num,
.score-num {
  display: inline-block;
  margin-bottom: 8px;
}
.score-num {
  margin-left: 16px;
  cursor: pointer;
}
.online-circle-wrap {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: $color-offline;
  &.is-online-wrap {
    background: $color-green;
  }
}
.strongest {
  position: absolute;
  bottom: 32px;
  right: 36px;
}
.user-info {
  padding: 0 16px;
}
.row-info {
  margin-bottom: 8px;
  font-size: 15px;
  line-height: 24px;
  &.uuid-row {
    display: flex;
    align-items: center;
  }
}
.link-box {
  display: flex;
  width: 100%;
  overflow: hidden;
  .link-url {
    width: 1px;
    flex: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color: #5d5dce;
    margin-left: 10px;
  }
}
.row-name {
  display: inline-block;
  width: 62px;
  margin-right: 10px;
  color: #636d86;
}
.nickname-row {
  display: flex;
  flex-wrap: wrap;
}
.validate-tag {
  display: flex;
  margin-bottom: 12px;
}

.self-photo {
  margin-right: 8px;
}
.admin-icon {
  margin-right: 4px;
}
.nicee-account {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  padding: 0 4px;
  border-radius: 20px;
  font-size: 12px;
  background: #e0efff;
  color: #222c43;
}
.copy-uuid-icon {
  margin-left: 5px;
  font-weight: 700;
  font-size: 14px;
  color: #3ab1ff;
  cursor: pointer;
}
.player-desc {
  margin-top: 16px;
  font-size: 15px;
  line-height: 22px;
  /deep/ .handle-button {
    text-align: right;
  }
}
.wrap-text {
  height: 100%;
  /deep/ .el-textarea__inner {
    background-color: none;
    border: none;
    padding: 0;
    font-style: normal;
    font-size: 15px;
    line-height: 22px;
    background: #ffffff;
    color: #222c43;
    cursor: unset;
  }
}
.edit-info {
  width: calc(100% - 32px);
  margin: 16px 16px 0 16px;
  /deep/ .button-box {
    background: #e8eaee;
  }
}
.some-handle {
  margin-top: 16px;
}
.order-rank {
  margin-top: 16px;
  background: #ffffff;
}
.right-tab {
  position: relative;
  overflow: hidden;
  display: flex;
  border-bottom: 1px solid #f3f3f3;
}
.skill-tab {
  height: 64px;
  max-width: 689px;
  flex-grow: 1;
  flex-shrink: 0;
  margin-left: 39px;
  /deep/ .right-arrow {
    width: 78px;
    right: 0px;
    background: linear-gradient(
      270deg,
      #ffffff 56.77%,
      rgba(255, 255, 255, 0) 100%
    );
  }
  /deep/ .arrow-icon {
    height: 30px;
    width: 30px;
    border: 1px solid #e8eaee;
    border-radius: 50%;
    color: #8c94aa;
    background: #ffffff;
  }
}
.tab-item {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  padding: 0 36px;
  white-space: nowrap;
  font-size: 20px;
  color: #8c94aa50;
  cursor: pointer;
}
.tab-active {
  font-weight: 500;
  color: #222c43;
  &:after {
    content: '';
    position: absolute;
    width: 46px;
    height: 6px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    background: #fed838;
    border-radius: 50px;
  }
}
.big-level-tag {
  height: 24px;
  width: 48px;
}
.coupon-banner {
  margin-left: 20px;
}
@media screen and (max-width: 599px) {
  .detail-page {
    width: 100vw;
    padding-top: 0px;
  }
  .play-detail {
    display: flex;
    flex-direction: column;
    width: 100vw;
    overflow: hidden;
  }
  .page-left {
    width: 100%;
    background: white;
  }
  .page-right {
    width: 100vw;
    border: none;
    margin-left: 0;
  }
  .skill-tab {
    height: 32px;
    max-width: calc(100% - 78px);
    /deep/ .left-arrow {
      width: 48px;
      left: -28px;
    }
    /deep/ .right-arrow {
      width: 48px;
      right: 0px;
    }
    /deep/ .arrow-icon {
      height: 24px;
      width: 24px;
      border: 1px solid #e8eaee;
      border-radius: 50%;
      color: #8c94aa;
    }
  }
  .tab-item {
    height: 32px;
    min-width: 72px;
    padding: 0 12px;
    font-size: 15px;
  }
  .tab-active {
    &:after {
      width: 30px;
      height: 3px;
    }
  }
  .user-info-header {
    flex-wrap: wrap;
    height: auto;
    /deep/ .coupon-container {
      width: 100vw;
      margin: 0;
      order: -1;
      margin-bottom: 10px;
    }
  }
}
</style>
